import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BathRoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function editBathRoomService(dto: BathRoomModel) {
  return await axios.put<ResponseObject<BathRoomModel>>(`${BASEURL}/bathRoom/updateBathRoom`, dto)
}
